import type { AxiosError } from 'axios'

const RETRYABLE_STATUS = new Set([408, 429, 500, 502, 503, 504])
const RETRYABLE_CODES = new Set(['ECONNABORTED', 'ETIMEDOUT', 'ECONNRESET', 'ERR_NETWORK'])

export function shouldRetry(error: AxiosError, attempt: number, maxRetries = 3): boolean {
  if (attempt >= maxRetries) return false
  if (error.code === 'ERR_CANCELED') return false
  const method = error.config?.method?.toUpperCase()
  if (method && !['GET', 'HEAD', 'OPTIONS'].includes(method)) return false
  if (!error.response && RETRYABLE_CODES.has(error.code || '')) return true
  if (error.response && RETRYABLE_STATUS.has(error.response.status)) return true
  return false
}

export function getRetryDelay(attempt: number): number {
  const baseDelay = 1000
  const maxDelay = 10000
  const exponentialDelay = baseDelay * Math.pow(2, attempt)
  const jitter = Math.random() * 0.3 * exponentialDelay
  return Math.min(exponentialDelay + jitter, maxDelay)
}

export function wait(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
